import { Form, type FormInstance } from 'antd';

import { CustomInputNumber } from '@app/components/CustomInputNumber';

import { FormItemField } from '../../FormItemField';

type NumberFieldProps = {
  label: string;
  fieldName: string | number | (string | number)[];
  form: FormInstance;
  min?: number;
  max?: number;
  disabled: boolean;
  required?: boolean;
  size?: 'small' | 'middle' | 'large';
};

export const NumberField = ({
  label,
  fieldName,
  form,
  min = 0.01,
  max,
  disabled,
  required,
  size = 'middle',
}: NumberFieldProps) => {
  const inputValue = Form.useWatch(fieldName, form);

  return (
    <FormItemField label={label} fieldName={fieldName} required={required}>
      <CustomInputNumber
        size={size}
        disabled={disabled}
        isAllowed={(floatValue: number) => {
          if (max !== undefined) {
            return floatValue >= min && floatValue <= max;
          }

          return floatValue >= min;
        }}
        inputValue={inputValue}
        onSuccess={({ value }) => {
          form.setFieldValue(fieldName, value);
        }}
      />
    </FormItemField>
  );
};
